var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: 'ScreenAsset', params: { id: _vm.assetnum }}}},[_c('button',{staticClass:"glossy-button glossy-button--green"},[_c('i',{staticClass:"fa fa-search"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }